<template>
  <Popover v-if="messageTextsFiltered.length" v-slot="{ open }">
    <Float
      :auto-placement="{
        autoAlignment: true,
        allowedPlacements: ['bottom', 'right']
      }"
      portal
      :offset="10"
    >
      <PopoverButton
        :class="open ? '' : 'text-opacity-90'"
        class="rounded border border-gray-300 px-2 py-1 leading-none"
      >
        <FontAwesomeIcon :icon="['far', 'feather']" />
      </PopoverButton>

      <PopoverPanel
        v-slot="{ close }"
        class="z-10 w-screen max-w-sm transform px-4 sm:max-w-md sm:px-0"
      >
        <div
          class="flex max-h-64 min-h-42 flex-col gap-1 overflow-y-auto rounded-md border bg-white p-2 shadow-2xl"
        >
          <template v-if="messageTextsFiltered">
            <button
              v-for="message_text in messageTextsFiltered"
              :key="message_text.id"
              class="hover:bg-primary-500 truncate rounded bg-gray-50 px-2 py-1 text-left hover:text-white"
              @click="getSelectedOptions(message_text.id, close)"
            >
              {{ message_text.title }}
            </button>
          </template>
          <div
            v-else
            class="flex h-36 flex-row items-center justify-center font-bold"
          >
            {{ $t('global.is_empty_list') }}
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'

export default {
  name: 'MessageTextsPopover',
  components: { Float, Popover, PopoverPanel, FontAwesomeIcon, PopoverButton },
  props: {
    modelType: {
      type: Object,
      required: true
    },
    modelId: {
      type: String,
      required: true
    },
    messageTextGroup: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update-message'],
  computed: {
    ...mapGetters({
      message_texts: 'metadata/getMessageTextsMetadata'
    }),
    messageTextsFiltered() {
      return (
        this.message_texts.all.filter((item) => {
          return (
            item.type === 'simple' &&
            item.groups.includes(this.messageTextGroup)
          )
        }) ?? []
      )
    }
  },
  methods: {
    ...mapActions({
      processFetchMessageTextConvertedAction:
        'messageText/fetchMessageTextConverted'
    }),
    getSelectedOptions(value, close) {
      console.log('value', value)
      this.processFetchMessageTextConvertedAction({
        model_type: this.modelType ?? null,
        model_id: this.modelId ?? null,
        message_text_id: value
      }).then((response) => {
        this.$emit('update-message', response.text)
      })
      close()
    }
  }
}
</script>
